import React, { useState, useEffect } from "react";
import { ref, get, update } from "firebase/database";
import { toast } from "react-toastify";
import { storage, database } from "../../../../firebase"; // Make sure to import your firebase instance
import {
  ref as storageRef,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import { Button } from "@mui/material";
import { Edit } from "@mui/icons-material";
const UserEdit = ({ user }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [contactPhone, setContactPhone] = useState("");
  const [contactTelphone, setContactTelphone] = useState("");
  const [profilePicture, setProfilePicture] = useState(null);
  const [companyName, setCompanyName] = useState("");
  const [googleMap, setGoogleMap] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [address, setAddress] = useState("");
  const [socialLinks, setSocialLinks] = useState({
    linkedin: "",
    twitter: "",
    instagram: "",
    facebook: "",
    github: "",
    youtube: "",
    website: "",
    reaProfile: "",
    RateMyAgent: "",
  });
  const [locationData, setLocationData] = useState(null);
  const [searchResults, setSearchResults] = useState([]);
  const [prevSearch, setPrevSearch] = useState("");
  //Upload function of file
  const uploadFile = async (file, folder) => {
    const fileRef = storageRef(storage, `${folder}/${file.name}`);
    const uploadTask = uploadBytesResumable(fileRef, file);

    return new Promise((resolve, reject) => {
      uploadTask.on(
        "state_changed",
        null,
        (error) => reject(error),
        async () => {
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
          resolve(downloadURL);
        }
      );
    });
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0]; // Get the selected file
    if (!file) return;
    debugger;
    try {
      const url = await uploadFile(file, "profiles"); // Upload the single file
      setProfilePicture(url); // Set the uploaded URL
      console.log("Uploaded URL:", url);
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  const handleSearch = (searchValue) => {
    if (searchValue.trim() && searchValue !== prevSearch) {
      setGoogleMap(searchValue);
      setPrevSearch(searchValue);

      const apiKey = "AIzaSyB1i-fQWxI7lnWHXr_YjrM5OwygCKJVY5g"; // Replace with your actual API key

      fetch(
        `https://maps.googleapis.com/maps/api/place/autocomplete/json?input=${searchValue}&key=${apiKey}`
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.predictions && data.predictions.length > 0) {
            setSearchResults(data.predictions);
          } else {
            setSearchResults([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching location data:", error);
          setSearchResults([]);
        });
    }
  };

  const handleSelectLocation = (location) => {
    setGoogleMap(location.display_name);
    setLocationData(location); // Store full data of the selected location
    setSearchResults([]);
  };

  useEffect(() => {
    const fetchData = async () => {
      const storedUserUID = user;
      if (storedUserUID) {
        try {
          const userRef = ref(database, "users/" + storedUserUID);
          const userSnapshot = await get(userRef);

          if (userSnapshot.exists()) {
            const user = userSnapshot.val();
            const companyId = user.companyId;

            if (companyId) {
              const companyRef = ref(database, "companies/" + companyId);
              const companySnapshot = await get(companyRef);

              if (companySnapshot.exists()) {
                const company = companySnapshot.val();
                setCompanyName(company.companyName || "");
              } else {
                console.error("Company not found");
                setCompanyName("");
              }

              const profileRef = ref(database, "profiles/" + storedUserUID);
              const profileSnapshot = await get(profileRef);

              if (profileSnapshot.exists()) {
                const profile = profileSnapshot.val();

                setFirstName(profile.firstName || "");
                setMiddleName(profile.middleName || "");
                setLastName(profile.lastName || "");
                setJobTitle(profile.jobTitle || "");
                setContactEmail(profile.contactEmail || "");
                setContactPhone(profile.contactPhone || "");
                setContactTelphone(profile.contactTelphone || "");
                setProfilePicture(profile.profilePicture || "");
                setGoogleMap(profile.googleMap || "");
                setDateOfBirth(profile.dateOfBirth || "");
                setAddress(profile.address || "");
                setSocialLinks(profile.socialLinks || {});
              }
            }
          }
        } catch (error) {
          console.error("Error fetching user or profile data", error);
        }
      }
    };

    fetchData();
  }, [user]);
  const handleSocialLinkChange = (platform, value) => {
    setSocialLinks((prevLinks) => ({
      ...prevLinks,
      [platform]: value,
    }));
  };
  const handleUpdate = async () => {
    const storedUserUID = user; // Ensure this is set to the logged-in user's UID
    if (storedUserUID) {
      const profileRef = ref(database, "profiles/" + storedUserUID);
      const userRef = ref(database, "users/" + storedUserUID);
      try {
        // Step 1: Get user data from Realtime Database
        // const userSnapshot = await get(userRef);
        // const userData = userSnapshot.val();

        // // Step 2: Get the current logged-in user from Firebase Authentication
        // const currentUser = userData.email; // This should be the current Firebase authenticated user object

        // // Step 3: If the current user and the new contact email are valid, update the email
        // if (currentUser && contactEmail) {

        //   await updateEmail(currentUser, contactEmail);
        //   console.log("Email updated successfully!");
        // }

        // Step 5: Update the email in the 'users' node in the Realtime Database
        await update(userRef, {
          email: contactEmail,
        });

        // Step 6: Update the profile data in the 'profiles' node
        await update(profileRef, {
          userId: storedUserUID,
          firstName,
          middleName,
          lastName,
          jobTitle,
          contactEmail,
          contactPhone,
          contactTelphone,
          profilePicture,
          companyName,
          locationData,
          googleMap,
          dateOfBirth,
          address,
          socialLinks,
        });

        toast.success("Profile updated successfully!");
        setIsOpen(false); // Close the modal or UI form
      } catch (error) {
        toast.error("Failed to save profile. Please try again.");
        console.error("Error saving profile:", error);
      }
    } else {
      toast.error("User not logged in. Please log in first.");
    }
  };
  return (
    <>
      <Button
        onClick={() => setIsOpen(true)}
        variant="contained"
        sx={{
          backgroundColor: "#1976d2", // Custom blue color
          color: "white",
          borderRadius: "5px",
          marginRight: 1,
          "&:hover": {
            backgroundColor: "#1565c0", // Darker shade on hover
          },
        }}
      >
       <Edit fontSize="small"/>
      </Button>

      {isOpen && (
        <div className="fixed inset-0 flex items-start justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white px-6 rounded-lg shadow-lg h-screen w-full max-w-6xl overflow-auto">
            <div className="flex justify-between items-center border-b pb-2 pt-5 sticky top-0 bg-white z-10">
              <h3 className="text-lg text-black text-start">Profile</h3>
              <button
                onClick={() => setIsOpen(false)}
                className="text-gray-500 hover:text-gray-800 text-4xl"
              >
                &times;
              </button>
            </div>

            <form>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 pt-4">
                {/* Profile Picture */}
                {profilePicture && (
                  <div className="mt-4 flex justify-center">
                    <img
                      src={profilePicture}
                      alt="Profile Preview"
                      className="w-32 h-32 rounded-full object-cover"
                    />
                  </div>
                )}
                <div className="mb-4 ">
                  <label
                    htmlFor="profilePicture"
                    className="block text-sm font-medium text-start text-gray-700"
                  >
                    Profile Picture
                  </label>
                  <input
                    id="profilePicture"
                    type="file"
                    accept="image/*"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg mt-2"
                    name="profilePicture"
                    onChange={handleFileChange}
                  />
                </div>
                {/* Job Title */}
                <div className="mb-4">
                  <label
                    htmlFor="jobTitle"
                    className="block text-sm font-medium  text-start text-gray-700"
                  >
                    Job Title
                  </label>
                  <input
                    id="jobTitle"
                    type="text"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg mt-2"
                    value={jobTitle}
                    onChange={(e) => setJobTitle(e.target.value)}
                  />
                </div>

                {/* First Name */}
                <div className="mb-4">
                  <label
                    htmlFor="firstName"
                    className="block text-sm font-medium  text-start text-gray-700"
                  >
                    First Name
                  </label>
                  <input
                    id="firstName"
                    type="text"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg mt-2"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                </div>
                {/* Middle Name */}
                <div className="mb-4">
                  <label
                    htmlFor="middleName"
                    className="block text-sm font-medium  text-start text-gray-700"
                  >
                    Middle Name
                  </label>
                  <input
                    id="middleName"
                    type="text"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg mt-2"
                    value={middleName}
                    onChange={(e) => setMiddleName(e.target.value)}
                  />
                </div>
                {/* Last Name */}
                <div className="mb-4">
                  <label
                    htmlFor="lastName"
                    className="block text-sm font-medium text-start text-gray-700"
                  >
                    Last Name
                  </label>
                  <input
                    id="lastName"
                    type="text"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg mt-2"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                  />
                </div>

                {/* Email Address */}
                <div className="mb-4">
                  <label
                    htmlFor="contactEmail"
                    className="block text-sm font-medium text-start text-gray-700"
                  >
                    Email Address
                  </label>
                  <input
                    id="contactEmail"
                    type="email"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg mt-2"
                    value={contactEmail}
                    onChange={(e) => setContactEmail(e.target.value)}
                    disabled
                  />
                </div>
                {/* Phone Number */}
                <div className="mb-4">
                  <label
                    htmlFor="contactPhone"
                    className="block text-sm font-medium text-start text-gray-700"
                  >
                    Phone Number
                  </label>
                  <input
                    id="contactPhone"
                    type="text"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg mt-2"
                    value={contactPhone}
                    onChange={(e) => setContactPhone(e.target.value)}
                  />
                </div>
                {/* Phone Number */}
                <div className="mb-4">
                  <label
                    htmlFor="contactTelphone"
                    className="block text-sm font-medium text-start text-gray-700"
                  >
                    Telphone
                  </label>
                  <input
                    id="contactTelphone"
                    type="text"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg mt-2"
                    value={contactTelphone}
                    onChange={(e) => setContactTelphone(e.target.value)}
                  />
                </div>

                {/* Date of Birth */}
                <div className="mb-4">
                  <label
                    htmlFor="dateOfBirth"
                    className="block text-sm font-medium text-start text-gray-700"
                  >
                    Date of Birth
                  </label>
                  <input
                    id="dateOfBirth"
                    type="date"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg mt-2"
                    value={dateOfBirth}
                    onChange={(e) => setDateOfBirth(e.target.value)}
                  />
                </div>
                {/* Address */}
                <div className="mb-4">
                  <label
                    htmlFor="address"
                    className="block text-sm font-medium text-start text-gray-700"
                  >
                    Address
                  </label>
                  <input
                    id="address"
                    type="text"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg mt-2"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                  />
                </div>

                <div className="mb-4 relative">
                  {/* Input Field */}
                  <label
                    htmlFor="googleMap"
                    className="block text-sm font-medium text-start text-gray-700"
                  >
                    Location
                  </label>
                  <input
                    id="googleMap"
                    type="text"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg mt-2"
                    value={googleMap} // Show selected name in the input field
                    onChange={(e) => handleSearch(e.target.value)} // Update search as user types
                    placeholder="Search for a location"
                  />

                  {/* Dropdown for search results */}
                  {searchResults.length > 0 && (
                    <ul className="absolute mt-1 sm:w-56 md:w-96 bg-white border border-gray-300 rounded-lg shadow-lg z-10">
                      {searchResults.map((location, index) => (
                        <li
                          key={index}
                          className="px-3 py-2 text-sm sm:text-base hover:bg-gray-100 cursor-pointer"
                          onClick={() => handleSelectLocation(location)} // Select the location
                        >
                          {location.display_name} {/* Show the address */}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
              {/* Social Media Links */}
              <div className="mt-6">
                <h3 className="text-lg text-black text-start mb-3">
                  Social Media Links
                </h3>
                <hr className="border-t-2 border-gray-200 mb-5" />
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {/* LinkedIn */}
                  <div className="mb-4">
                    <label
                      htmlFor="linkedin"
                      className="block text-sm font-medium text-start text-gray-700"
                    >
                      LinkedIn
                    </label>
                    <input
                      id="linkedin"
                      type="text"
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg mt-2"
                      value={socialLinks.linkedin}
                      onChange={(e) =>
                        handleSocialLinkChange("linkedin", e.target.value)
                      }
                    />
                  </div>
                  {/* Twitter */}
                  <div className="mb-4">
                    <label
                      htmlFor="twitter"
                      className="block text-sm font-medium text-start text-gray-700"
                    >
                      Twitter
                    </label>
                    <input
                      id="twitter"
                      type="text"
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg mt-2"
                      value={socialLinks.twitter}
                      onChange={(e) =>
                        handleSocialLinkChange("twitter", e.target.value)
                      }
                    />
                  </div>
                  {/* Instagram */}
                  <div className="mb-4">
                    <label
                      htmlFor="instagram"
                      className="block text-sm font-medium text-start text-gray-700"
                    >
                      Instagram
                    </label>
                    <input
                      id="instagram"
                      type="text"
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg mt-2"
                      value={socialLinks.instagram}
                      onChange={(e) =>
                        handleSocialLinkChange("instagram", e.target.value)
                      }
                    />
                  </div>
                  {/* facebook */}
                  <div className="mb-4">
                    <label
                      htmlFor="facebook"
                      className="block text-sm font-medium text-start text-gray-700"
                    >
                      Facebook
                    </label>
                    <input
                      id="facebook"
                      type="text"
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg mt-2"
                      value={socialLinks.facebook}
                      onChange={(e) =>
                        handleSocialLinkChange("facebook", e.target.value)
                      }
                    />
                  </div>
                  {/* GitHub */}
                  <div className="mb-4">
                    <label
                      htmlFor="github"
                      className="block text-sm font-medium text-start text-gray-700"
                    >
                      GitHub
                    </label>
                    <input
                      id="github"
                      type="text"
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg mt-2"
                      value={socialLinks.github || ""}
                      onChange={(e) =>
                        handleSocialLinkChange("github", e.target.value)
                      }
                    />
                  </div>
                  {/* YouTube */}
                  <div className="mb-4">
                    <label
                      htmlFor="youtube"
                      className="block text-sm font-medium text-start text-gray-700"
                    >
                      YouTube
                    </label>
                    <input
                      id="youtube"
                      type="text"
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg mt-2"
                      value={socialLinks.youtube || ""}
                      onChange={(e) =>
                        handleSocialLinkChange("youtube", e.target.value)
                      }
                    />
                  </div>
                  {/* Website */}
                  <div className="mb-4">
                    <label
                      htmlFor="website"
                      className="block text-sm font-medium text-start text-gray-700"
                    >
                      Website
                    </label>
                    <input
                      id="website"
                      type="text"
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg mt-2"
                      value={socialLinks.website || ""}
                      onChange={(e) =>
                        handleSocialLinkChange("website", e.target.value)
                      }
                    />
                  </div>
                  {/* reaProfile */}
                  <div className="mb-4">
                    <label
                      htmlFor="reaProfile"
                      className="block text-sm font-medium text-start text-gray-700"
                    >
                      Rea Profile
                    </label>
                    <input
                      id="reaProfile"
                      type="text"
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg mt-2"
                      value={socialLinks.reaProfile || ""}
                      onChange={(e) =>
                        handleSocialLinkChange("reaProfile", e.target.value)
                      }
                    />
                  </div>
                  <div className="mb-4">
                    <label
                      htmlFor="RateMyAgent"
                      className="block text-sm font-medium text-start text-gray-700"
                    >
                      Rate My Agent Link
                    </label>
                    <input
                      id="RateMyAgent"
                      type="text"
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg mt-2"
                      value={socialLinks.RateMyAgent}
                      onChange={(e) =>
                        handleSocialLinkChange("RateMyAgent", e.target.value)
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-start my-8">
                <button
                  type="button"
                  className="px-6 py-3 bg-black text-white rounded-lg"
                  onClick={handleUpdate}
                >
                  Update Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default UserEdit;
